import {
    Component,
    ContentChildren,
    HostBinding,
    AfterContentInit,
    QueryList,
    Output,
    Input,
    EventEmitter,
    TemplateRef
} from '@angular/core';
import { ZQTabComponent } from '../zq-tab/zq-tab.component';

@Component({
    standalone: false,
    selector: 'zq-tab-group',
    templateUrl: './zq-tab-group.component.html',
    styleUrls: ['./zq-tab-group.component.scss']

})
export class ZQTabGroupComponent implements AfterContentInit {
    private currentTab: ZQTabComponent;

    @ContentChildren(ZQTabComponent)
    public tabs: QueryList<ZQTabComponent>;

    @HostBinding('class')
    public readonly hostClass = 'zq-tab-group';

    @Input()
    public readonly emptyDefault = false;

    @Input()
    public currentTabLabel: string = null;

    @Input()
    templateRef: TemplateRef<any>;

    @Output()
    public currentTabLabelChange = new EventEmitter<string>();

    ngAfterContentInit() {
        if (!this.tabs.length) {
            return;
        }

        const activeTab = this.tabs.find(tab => !tab.disabled && (tab.label === this.currentTabLabel || tab.active));
        const defaultTab = this.tabs.find(tab => !tab.disabled);

        if (activeTab || !this.emptyDefault) {
            this.selectTab(activeTab || defaultTab);
        }
        // console.log('ZQTabGroupComponent.ngAfterContentInit');
    }

    public selectTab(tab?: ZQTabComponent) {
        if (!tab || tab.disabled) {
            return;
        }

        this.tabs.toArray().forEach(t => (t.active = false));
        tab.active = true;
        this.currentTab = tab;
        this.currentTabLabelChange.emit(this.currentTab.label);
    }
}
